import '../App.css'
import getApiBaseUrl from '../utils/apiConfig';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Modal, Button, Form } from 'react-bootstrap';
import React from 'react';
import NetInfo from "@react-native-community/netinfo";
import Select from 'react-select'
import QRCode from 'qrcode';
import socketIO from "socket.io-client";
import icon from '../images/dogeIcon.png';
import btcIcon from '../images/btcIcon.png';
import ltcIcon from '../images/ltcIcon.png';
import kioskCheesy from '../images/kiosk-cheesy.png'
import { fetchDogeUsdRate, dogeToUsd, usdToDoge } from "../utils/price";
import bell from '../bell.mp3'
import splash from '../images/splash.png';
import logo from '../images/de.png'
import mydoge from '../images/mydoge.webp'
import coinbase from '../images/coinbasewallet.png'
import exodus from '../images/exodus.png'
import trust from '../images/trustwallet.png'
import safepal from '../images/safepal.png'
import atomic from '../images/atomic.jpeg'
import AsyncStorage from '@react-native-async-storage/async-storage';
import Canvas from '../components/Canvas'
import PasswordPrompt from '../components/PasswordPrompt'
import Splash from './Splash'
import DataEntry from './DataEntry'
import Tip from './Tip'

export class Main extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			page: -2,
      numerals: [],
      order: [],
      keypadToggle: 'balance',
      price: 1,
      completed: false,
      squareOrder: {total_money: {}, total_tip_money: {}},
      toastOrder: {total_money: {}, total_tip_money: {}},
      fiatConversionRate: 1,
      selectedCrypto: null,
      availableCryptos: [], // Track which cryptos have configured wallets
      showCustomTipModal: false,
      customTipInput: '',
      customTipError: '',
      // Trust minimization limits
      limitsExceeded: false,
      exceededCoins: [],
      limitCheckInProgress: false,
      // Account suspension
      isSuspended: false,
      suspensionReason: null,
      suspensionContact: 'support@dijitto.io',
      // Password prompt modals
      showAdminPasswordPrompt: false,
      showSystemPasswordPrompt: false
		};

    this.audio = new Audio(bell)
    this.checkPaymentTimer = null // Track the checkPayment timer to prevent multiple loops
    this.maxPaymentTimer = null // Track max payment timeout (5 min) for abandoned transactions

		this.handleClickDoge = this.handleClickDoge.bind(this);
		this.handleKeyClick = this.handleKeyClick.bind(this);
		this.handleContinueClick = this.handleContinueClick.bind(this);
    this.total = this.total.bind(this)
		this.setQRCode = this.setQRCode.bind(this);
		this.checkPayment = this.checkPayment.bind(this);
    this.paymentUrl = this.paymentUrl.bind(this)
    this.handleTip = this.handleTip.bind(this)
    this.toggleEntry = this.toggleEntry.bind(this)
    this.handleClickSplash = this.handleClickSplash.bind(this)
    this.handleReset = this.handleReset.bind(this)
    this.handleAdminClick = this.handleAdminClick.bind(this)
    this.handleSystemClick = this.handleSystemClick.bind(this)
    this.handleChooseWallet = this.handleChooseWallet.bind(this)
    this.triggerDogeRain = this.triggerDogeRain.bind(this)
    this.createFallingDoge = this.createFallingDoge.bind(this)
    this.handleSelectCrypto = this.handleSelectCrypto.bind(this)
    this.checkLimits = this.checkLimits.bind(this)
    this.showCloseOutPrompt = this.showCloseOutPrompt.bind(this)
    this.checkSuspensionStatus = this.checkSuspensionStatus.bind(this)
  }

  async componentDidMount() {
    const checkAndSetConfig = async () => {
      const keyPairs = [
        {storeKey: 'store-id', stateKey: 'storeId'},
        {storeKey: 'api-key', stateKey: 'apiKey'},
        {storeKey: 'posMode', stateKey: 'posMode'},
        {storeKey: 'merchantId', stateKey: 'merchantId'},
        {storeKey: 'currency', stateKey: 'currency'},
        {storeKey: 'tipsMode', stateKey: 'tipsMode'},
        {storeKey: 'tipOnlyMode', stateKey: 'tipOnlyMode'},
        {storeKey: 'feePassthrough', stateKey: 'feePassthrough'},
        {storeKey: 'dijittoFeePercentage', stateKey: 'dijittoFeePercentage'},
        {storeKey: 'discount', stateKey: 'discount'},
        {storeKey: 'splash', stateKey: 'splash'},
        {storeKey: 'fiatCurrency', stateKey: 'fiatCurrency'},
        {storeKey: 'fiatSymbol', stateKey: 'fiatSymbol'},
        {storeKey: 'topText', stateKey: 'topText'},
        {storeKey: 'middleText', stateKey: 'middleText'},
        {storeKey: 'bottomText', stateKey: 'bottomText'}
      ]
      for (var i = 0; i < keyPairs.length; i++) {
        var keyPair = keyPairs[i]
        // const storeKey = 'store-id'
        const storeVal = await AsyncStorage.getItem(keyPair.storeKey)
        if (storeVal) {
          // Don't check limits on page load - only when user tries to proceed
          if (keyPair.stateKey === 'storeId') {
            this.setState({[keyPair.stateKey]: storeVal}, () => {
              console.log('✅ StoreId set in state:', this.state.storeId);
              // Check if account is suspended
              this.checkSuspensionStatus();
            });
          } else {
            this.setState({[keyPair.stateKey]: storeVal})
          }
        }
        if (keyPair.storeKey === 'fiatCurrency') {
          const currency = storeVal || 'USD';
          fetch(`https://openexchangerates.org/api/latest.json?app_id=375ab47571dc4deca1c90f23e7298bd7&symbols=${currency}&prettyprint=false&show_alternative=false`,
            {
              headers: {
                'Content-Type': 'application/json',
              },
            }
          ).then(res => res.json()
          ).then(payload =>
            {
              // console.log('crrency: ', currency);
              // console.log(payload)
              // console.log('got conversion rate: ', payload.rates[currency])
              this.setState({fiatConversionRate: payload.rates[currency]});
            }
          )
        }
      }

      // Check which cryptocurrencies have configured wallets
      const availableCryptos = [];
      const btcXpub = await AsyncStorage.getItem('api-xpub-btc');
      const ltcXpub = await AsyncStorage.getItem('api-xpub-ltc');
      const dogeXpub = await AsyncStorage.getItem('api-xpub-doge');

      if (btcXpub) availableCryptos.push('btc');
      if (ltcXpub) availableCryptos.push('ltc');
      if (dogeXpub) availableCryptos.push('doge');

      console.log('Available cryptocurrencies:', availableCryptos);
      this.setState({availableCryptos});
    }

    const setDefaultCrypto = async () => {
      // Check which wallets are configured by looking for xpub keys in AsyncStorage
      // Priority: DOGE > BTC > LTC
      const dogeXpub = await AsyncStorage.getItem('api-xpub-doge');
      const btcXpub = await AsyncStorage.getItem('api-xpub-btc');
      const ltcXpub = await AsyncStorage.getItem('api-xpub-ltc');

      console.log('Checking wallet configuration:', {
        hasDoge: !!dogeXpub,
        hasBtc: !!btcXpub,
        hasLtc: !!ltcXpub
      });

      // Select default crypto based on priority
      let defaultCrypto = null;
      if (dogeXpub) {
        defaultCrypto = 'doge';
        console.log('Default crypto: DOGE (wallet configured)');
      } else if (btcXpub) {
        defaultCrypto = 'btc';
        console.log('Default crypto: BTC (wallet configured, no DOGE)');
      } else if (ltcXpub) {
        defaultCrypto = 'ltc';
        console.log('Default crypto: LTC (wallet configured, no DOGE or BTC)');
      } else {
        // Fallback to DOGE if no wallets are configured
        defaultCrypto = 'doge';
        console.log('Default crypto: DOGE (no wallets configured, using default)');
      }

      this.setState({ selectedCrypto: defaultCrypto });
    }

    await checkAndSetConfig();
    await setDefaultCrypto();

    // Note: checkLimits() is now called from within checkAndSetConfig's setState callback
    // to ensure storeId is actually set before checking limits
	}

  componentWillUnmount() {
    // Clean up timers when navigating away from payment screen
    console.log('🛑 Component unmounting - cleaning up payment timers');

    if (this.checkPaymentTimer) {
      clearTimeout(this.checkPaymentTimer);
      this.checkPaymentTimer = null;
      console.log('✅ Cleared payment check timer');
    }

    if (this.maxPaymentTimer) {
      clearTimeout(this.maxPaymentTimer);
      this.maxPaymentTimer = null;
      console.log('✅ Cleared max payment timeout');
    }
  }

  async handleClickSplash() {
    // Check if account is suspended first
    if (this.state.isSuspended) {
      alert(`ACCOUNT SUSPENDED\n\n${this.state.suspensionReason}\n\nYour account has been suspended and you cannot accept payments.\n\nPlease contact support: ${this.state.suspensionContact}`);
      return; // Block new transaction
    }

    // Check limits when user tries to proceed (not on page load)
    const limitExceeded = await this.checkLimits();

    // If limits exceeded, block the transaction
    if (limitExceeded) {
      console.log('🚫 Transaction blocked - limits exceeded');
      return; // Block new transaction
    }

    NetInfo.fetch().then((state) => {
          if (!state.isConnected) {
            window.alert(
              "No Connection. Much sorry. So interrupt.\nPlease check your internet connection and try again.",
              [
                { text: "OK" }
              ],
              { cancelable: false }
            );
            this.handleReset();
          }
        });

    if (this.state.posMode === 'square' || this.state.posMode === 'toast') {
      let eventUrl = `${getApiBaseUrl()}/square_events.json?merchant_id=${this.state.merchantId}`
      fetch(eventUrl).then(
        res => res.json()
      ).then(
        posEvent => {
          if (posEvent.id) {
          // this.setState({tipSelect: 'tip-no'}, this.handleContinueClick)
            let posMode = this.state.posMode
            let stats
            if (posMode === 'square') {
              stats = 'Confirm order #' + posEvent.order.id + ' for total $' + (posEvent.order.total_money.amount/100).toFixed(2)
            } else if (posMode === 'toast') {
              stats = 'Confirm order #' + posEvent.data.id + "\nFor total $" + posEvent.total_money.amount.toFixed(2)
            }
            let confirm = window.confirm(stats)
            if (confirm) {
              this.handleContinueClick()
            } else {
              this.setState({page: 0})
            }
          } else {
            this.setState({page: 0})
          }
        }
      )
    } else {
      console.log('click')
      if (this.state.storeId === 0) {
        this.setState({page: 2})
      } else if (this.state.tipOnlyMode === 'true') {
        // Tip Only Mode: Skip amount entry, go directly to tip selection
        console.log('Tip Only Mode - skipping amount entry');
        this.setState({
          numerals: [],               // No subtotal - tip IS the total
          order: ['T', 'I', 'P'],     // Order ID = "TIP"
          page: 2  // Go directly to tip screen
        });
      } else {
        this.setState({page: 0})
      }
    }
  }

	handleClickDoge() {
    if (this.state.numerals.length === 0) {
      return
    }
    if (this.state.order.length === 0) {
      return
    }
    if (this.state.tipsMode === 'false') {
      // this.setState({page: 3});
      this.handleContinueClick();
    } else {
  		this.setState({page: 2});
    }
	}

	handleKeyClick(e) {
    if (e.target.innerText === "C") {
      console.log('clear')
      if (this.state.keypadToggle === 'balance') {
        this.setState({numerals: []});
      } else if (this.state.keypadToggle === 'order') {
        this.setState({order: []});
      }
      return
    }
    if (e.target.innerText === 'DEL') {
      if (this.state.keypadToggle === 'balance') {
    		this.setState((state, props) => ({
    		  numerals: state.numerals.slice(0,-1)
    		}))
      } else if (this.state.keypadToggle === 'order') {
    		this.setState((state, props) => ({
    		  order: state.order.slice(0,-1)
    		}))
      }
      return
    }

    if (this.state.keypadToggle === 'balance') {
  		this.setState((state, props) => ({
  		  numerals: [...state.numerals, e.target.innerText]
  		}))
    } else if (this.state.keypadToggle === 'order') {
  		this.setState((state, props) => ({
  		  order: [...state.order, e.target.innerText]
  		}))
    }
	}

  handleTip(id) {
    console.log(id)
    this.setState({tipSelect: id})
    if (id === 'tip-cust') {
      // If there's an existing custom tip, convert it to cents format
      let initialValue = '0'
      if (this.state.customTip) {
        const cents = Math.round(this.state.customTip * 100)
        initialValue = cents.toString()
      }

      this.setState({
        showCustomTipModal: true,
        customTipInput: initialValue,
        customTipError: ''
      })
    }
  }

  handleCustomTipChange = (e) => {
    this.setState({ customTipInput: e.target.value, customTipError: '' })
  }

  handleTipKeypadPress = (key) => {
    let { customTipInput } = this.state

    // Remove any formatting to get raw number
    let rawValue = customTipInput.replace(/[^0-9]/g, '')

    if (key === 'backspace') {
      // Remove last digit
      rawValue = rawValue.slice(0, -1)
    } else if (key === '.00') {
      // Add two zeros (multiply by 100)
      rawValue = rawValue + '00'
    } else if (key === 'clear') {
      rawValue = ''
    } else {
      // Add digit (0-9)
      rawValue = rawValue + key
    }

    // Limit to reasonable amount (999999 cents = $9999.99)
    if (rawValue.length > 6) {
      return
    }

    // Store the raw value for processing
    this.setState({
      customTipInput: rawValue || '0',
      customTipError: ''
    })
  }

  formatTipDisplay = (rawValue) => {
    if (!rawValue || rawValue === '0') return '0.00'

    // Pad with zeros if needed
    const padded = rawValue.padStart(3, '0')

    // Insert decimal point (last 2 digits are cents)
    const dollars = padded.slice(0, -2)
    const cents = padded.slice(-2)

    return `${dollars}.${cents}`
  }

  handleCustomTipSubmit = () => {
    const { customTipInput } = this.state

    // Get formatted value
    const displayValue = this.formatTipDisplay(customTipInput)
    const amount = parseFloat(displayValue)

    if (amount === 0) {
      this.setState({ customTipError: 'Please enter a tip amount greater than $0.00' })
      return
    }

    // Valid tip - save it and close modal
    this.setState({
      customTip: amount,
      showCustomTipModal: false,
      customTipInput: '',
      customTipError: ''
    })
  }

  handleCustomTipCancel = () => {
    this.setState({
      showCustomTipModal: false,
      customTipInput: '',
      customTipError: '',
      tipSelect: null // Deselect custom tip if canceled
    })
  }

  toggleEntry(n) {
    this.setState({keypadToggle: n})
  }

	handleContinueClick() {
    console.log('continue click>>>')
    let posMode = this.state.posMode
    console.log(this.state.tipSelect)
    console.log(posMode)
    console.log(this.state.tipsMode)
    console.log('<<<')

    if (!this.state.tipSelect && posMode !== 'square' && posMode !== 'toast' && this.state.tipsMode !== 'false') {
      console.log('no tip select, and was not pos mode or tips off')
      return
    }
    console.log('setting page to 3')
		this.setState({page: 3});
    let priceUrl = `${getApiBaseUrl()}/price`
    fetch(priceUrl)
      .then(res => {
        console.log('price res')
        console.log(res)
        return res.json()
      })
      .then(payload => {
        console.log('price payload')
        console.log(payload)
        // Get price based on selected cryptocurrency
        let price;
        const selectedCrypto = this.state.selectedCrypto || 'doge';
        if (selectedCrypto === 'btc') {
          price = payload.data.BTC.price;
        } else if (selectedCrypto === 'ltc') {
          price = payload.data.LTC.price;
        } else {
          price = payload.data.DOGE.price;
        }
        console.log(`Selected crypto: ${selectedCrypto}, price: $${price}`)
        this.setState({price: price})
        console.log(price)

        if (this.state.posMode === 'square' || this.state.posMode === 'toast') {
          let eventUrl = `${getApiBaseUrl()}/square_events.json?merchant_id=${this.state.merchantId}`
          fetch(eventUrl).then(
              res => res.json()
          ).then(
              event => {
                let amount_usd
                let amount_doge
                let tip_doge
                let amount_total_doge
                let order_id

                if (this.state.posMode === 'square') {
                  this.setState({squareOrder: event.order})

                  amount_usd = event.order.total_money.amount/100
                  amount_doge = amount_usd/price
                  tip_doge = (event.order.total_tip_money.amount/100)/price
                  amount_total_doge = amount_doge // + tip_doge
                  order_id = event.order.id
                } else {
                  this.setState({toastOrder: event})

                  amount_usd = event.total_money.amount
                  amount_doge = amount_usd/price
                  tip_doge = (event.total_tip_money.amount)/price
                  amount_total_doge = amount_doge // + tip_doge
                  order_id = event.id
                }

                let keyVals = [
                  `order_id=${order_id}`,
                  `amount=${amount_total_doge}`,
                  `tip=${tip_doge}`,
                  `store_id=${this.state.storeId}`,
                  `merchant_id=${this.state.merchantId}`,
                  `crypto=${this.state.selectedCrypto || 'doge'}`,
                ]
                if (this.state.apiKey) {
                  keyVals.push(`key=${this.state.apiKey}`)
                }
                let rparams = keyVals.join('&')
                let walletUrl = `${getApiBaseUrl()}/payments/new?${rparams}`

                fetch(walletUrl).then(resaddr => resaddr.text())
                  .then(txtaddr => {
                    let addr = txtaddr;

                    let paymentAddr = addr.trim()
                    let paymentAmount = amount_total_doge
                    this.setState({paymentAddr, paymentAmount})
                    // console.log(paymentUrl)
                    // DON'T start payment checking yet - wait until wallet is selected and QR generated
                    // this.checkPaymentTimer = setTimeout(this.checkPayment, 500, addr)
                    // QRCode.toDataURL(paymentUrl, this.setQRCode);
                })

              }
          )
        } else {
          let discount = 0;
          let amount_usd = this.total()*(1 - discount/100)
          let amount_doge = amount_usd/price
          let tip_doge = this.tip()/this.getDogeUSDRate(price)
          let amount_total_doge = amount_doge + tip_doge
          console.log('final balance: ', this.finalBalance(price))
          console.log('doge price in usd from state: ', this.state.price)
          console.log('doge price in usd fetch: ', price)
          console.log('doge fiat rate: ', this.getDogeUSDRate(price))
          console.log('final doge balance: ', this.finalDogeBalance(price))
          let keyVals = [
            `order_id=${this.state.order.join('')}`,
            `amount=${this.finalDogeBalance(price)}`,
            `tip=${tip_doge}`,
            `store_id=${this.state.storeId}`,
            `crypto=${this.state.selectedCrypto || 'doge'}`,
          ]
          if (this.state.apiKey) {
            keyVals.push(`key=${this.state.apiKey}`)
          }
          let rparams = keyVals.join('&')
          let walletUrl = `${getApiBaseUrl()}/payments/new?${rparams}`
          fetch(walletUrl).then(resaddr => resaddr.text())
            .then(txtaddr => {
              let addr = txtaddr;

              let paymentAddr = addr.trim()
              let paymentAmount = this.finalBalance()/price
              this.setState({paymentAddr, paymentAmount})
              // console.log(paymentUrl)
              // DON'T start payment checking yet - wait until wallet is selected and QR generated
              // this.checkPaymentTimer = setTimeout(this.checkPayment, 500, addr)
              // QRCode.toDataURL(paymentUrl, this.setQRCode);
          })
        }

      });
	}

  paymentUrl() {
    const selectedCrypto = this.state.selectedCrypto || 'doge';
    let protocol;
    if (selectedCrypto === 'btc') {
      protocol = 'bitcoin';
    } else if (selectedCrypto === 'ltc') {
      protocol = 'litecoin';
    } else {
      protocol = 'dogecoin';
    }
    let url = `${protocol}:${this.state.paymentAddr}`
    if (this.state.walletApp && (this.state.walletApp.value !== 'Coinbase')) {
      url = url + `?amount=${this.state.paymentAmount}`
    }
    return url
  }

  handleReset() {
    // Clear any active timers before resetting
    if (this.checkPaymentTimer) {
      clearTimeout(this.checkPaymentTimer)
      this.checkPaymentTimer = null
    }
    if (this.maxPaymentTimer) {
      clearTimeout(this.maxPaymentTimer)
      this.maxPaymentTimer = null
    }
    window.location = '/'
  }

  // Trust Minimization: Check if store has exceeded limits
  // Returns true if limits exceeded (block transaction), false if ok to proceed
  async checkLimits() {
    console.log('🔍 checkLimits() called, storeId:', this.state.storeId);

    // Don't check if already checking (prevent race conditions)
    if (this.state.limitCheckInProgress) {
      console.log('⏭️ Limit check already in progress, skipping');
      return false; // Don't block if we can't check
    }

    // Don't check if transaction is in progress
    if (this.state.paymentAddr || this.state.qrCode) {
      console.log('⏭️ Transaction in progress, skipping limit check');
      return false; // Don't block if we can't check
    }

    // Don't check if no store ID set
    if (!this.state.storeId || this.state.storeId === 'Unset') {
      console.log('⏭️ No store ID set, skipping limit check. storeId:', this.state.storeId);
      return false; // Don't block if we can't check
    }

    console.log('✅ Proceeding with limit check for store:', this.state.storeId);
    this.setState({ limitCheckInProgress: true });

    try {
      const apiBase = getApiBaseUrl();

      const response = await fetch(`${apiBase}/stores/${this.state.storeId}/check-limits`);
      const limits = await response.json();

      // Check if ANY crypto exceeded
      const exceededCoins = [];
      if (limits.btc && limits.btc.exceeded) exceededCoins.push('BTC');
      if (limits.ltc && limits.ltc.exceeded) exceededCoins.push('LTC');
      if (limits.doge && limits.doge.exceeded) exceededCoins.push('DOGE');

      if (exceededCoins.length > 0) {
        this.setState({
          limitsExceeded: true,
          exceededCoins: exceededCoins,
          limitCheckInProgress: false
        });
        this.showCloseOutPrompt(exceededCoins, limits);
        return true; // Block transaction - limits exceeded
      } else {
        this.setState({
          limitsExceeded: false,
          exceededCoins: [],
          limitCheckInProgress: false
        });
        return false; // Ok to proceed
      }
    } catch (error) {
      console.error('Error checking limits:', error);
      this.setState({ limitCheckInProgress: false });
      return false; // Don't block if error checking limits
    }
  }

  // Trust Minimization: Show prompt to complete close-out flow
  showCloseOutPrompt(exceededCoins, limits) {
    const mode = limits && limits[exceededCoins[0]?.toLowerCase()]?.mode;

    let message = '';
    if (mode === 'coin_max') {
      message = `⚠️ CLOSE-OUT REQUIRED\n\nYou've reached your limit for: ${exceededCoins.join(', ')}\n\n`;
      exceededCoins.forEach(coin => {
        const limit = limits[coin.toLowerCase()];
        if (limit) {
          message += `${coin}: ${limit.current.toFixed(8)} / ${limit.limit.toFixed(8)}\n`;
        }
      });
      message += '\n⛔ You cannot accept new payments until you complete the Close Out Flow in the Admin panel.';
    } else if (mode === 'time_max') {
      message = `⚠️ CLOSE-OUT REQUIRED\n\nTime limit reached for: ${exceededCoins.join(', ')}\n\n`;
      exceededCoins.forEach(coin => {
        const limit = limits[coin.toLowerCase()];
        if (limit) {
          const daysText = limit.days_since ? `${limit.days_since} days` : 'Never closed out';
          message += `${coin}: ${daysText} (limit: ${limit.limit_days} days)\n`;
        }
      });
      message += '\n⛔ You cannot accept new payments until you complete the Close Out Flow in the Admin panel.';
    } else {
      // Fallback message if mode is unknown
      message = `⚠️ CLOSE-OUT REQUIRED\n\nYou've reached your limit for: ${exceededCoins.join(', ')}\n\n⛔ You cannot accept new payments until you complete the Close Out Flow in the Admin panel.`;
    }

    // Alert user (only OK button, no cancel option)
    window.alert(message + '\n\nYou will now be redirected to the Admin panel to complete the Close Out Flow.');

    // Automatically redirect to admin panel
    window.location = '/admin';
  }

  async checkSuspensionStatus() {
    if (!this.state.storeId || this.state.storeId === 'Unset') {
      return;
    }

    try {
      const apiBase = process.env.REACT_APP_API_BASE_URL || getApiBaseUrl();
      const response = await fetch(`${apiBase}/stores/${this.state.storeId}/suspension-status`);

      if (!response.ok) {
        console.error('Failed to check suspension status:', response.status);
        return;
      }

      const data = await response.json();

      if (data.is_suspended) {
        this.setState({
          isSuspended: true,
          suspensionReason: data.suspension_reason,
          suspensionContact: 'support@dijitto.io'
        });

        // Show suspension modal
        alert(`ACCOUNT SUSPENDED\n\nYour account has been suspended due to unauthorized wallet activity.\n\nTo discuss reactivation, please contact:\nEmail: support@dijitto.io\nSubject: "Store Reactivation Request - ${this.state.storeId}"\n\nInclude your Store ID and explain the situation.`);
      }
    } catch (error) {
      console.error('Error checking suspension status:', error);
    }
  }

  handleChooseWallet(walletApp) {
    this.setState({walletApp}, () => {
        const qrUrl = this.paymentUrl();
        console.log('=== QR Code Generation ===');
        console.log('Selected crypto:', this.state.selectedCrypto);
        console.log('Wallet:', walletApp.value);
        console.log('Payment address:', this.state.paymentAddr);
        console.log('Payment amount:', this.state.paymentAmount);
        console.log('Full QR URL:', qrUrl);
        console.log('========================');
        QRCode.toDataURL(qrUrl, this.setQRCode)

        // NOW start payment checking - wallet selected, QR generated, ready to receive payment
        console.log('🚀 Starting payment monitoring for address:', this.state.paymentAddr);
        if (this.checkPaymentTimer) {
          clearTimeout(this.checkPaymentTimer)
        }
        this.checkPaymentTimer = setTimeout(this.checkPayment, 500, this.state.paymentAddr)

        // Start 2-minute timeout for abandoned transactions
        if (this.maxPaymentTimer) {
          clearTimeout(this.maxPaymentTimer)
        }
        this.maxPaymentTimer = setTimeout(() => {
          console.log('⏰ Payment timeout - No payment received within 2 minutes');
          console.log('Stopping payment monitoring and returning to home screen');

          // Clear the payment checking timer
          if (this.checkPaymentTimer) {
            clearTimeout(this.checkPaymentTimer)
            this.checkPaymentTimer = null
          }

          // Return to home screen
          window.location = '/'
        }, 120000) // 120 seconds (2 minutes)
        console.log('⏰ Max payment timer set: 2 minutes')
      }
    )
  }

  handleSelectCrypto(crypto) {
    // Clear any existing payment check timer to prevent multiple loops
    if (this.checkPaymentTimer) {
      clearTimeout(this.checkPaymentTimer)
      this.checkPaymentTimer = null
    }

    // Clear max payment timeout when switching cryptos
    if (this.maxPaymentTimer) {
      clearTimeout(this.maxPaymentTimer)
      this.maxPaymentTimer = null
    }

    // Reset wallet selection and QR code, then fetch new price for selected crypto
    this.setState({selectedCrypto: crypto, walletApp: null, qrCodeUrl: null}, () => {
      // Fetch updated price for the selected cryptocurrency
      const priceUrl = `${getApiBaseUrl()}/price`
      fetch(priceUrl)
        .then(res => res.json())
        .then(payload => {
          let price;
          if (crypto === 'btc') {
            price = payload.data.BTC.price;
          } else if (crypto === 'ltc') {
            price = payload.data.LTC.price;
          } else {
            price = payload.data.DOGE.price;
          }
          console.log(`Crypto changed to ${crypto}, new price: $${price}`)
          this.setState({price: price})

          // Regenerate payment address for the new cryptocurrency
          let tip_doge = this.tip()/price
          let keyVals = [
            `order_id=${this.state.order.join('')}`,
            `amount=${this.finalBalance()/price}`,
            `tip=${tip_doge}`,
            `store_id=${this.state.storeId}`,
            `crypto=${crypto}`,
          ]
          if (this.state.apiKey) {
            keyVals.push(`key=${this.state.apiKey}`)
          }
          let rparams = keyVals.join('&')
          let walletUrl = `${getApiBaseUrl()}/payments/new?${rparams}`
          fetch(walletUrl).then(resaddr => resaddr.text())
            .then(txtaddr => {
              let addr = txtaddr;
              let paymentAddr = addr.trim()
              let paymentAmount = this.finalBalance()/price
              this.setState({paymentAddr, paymentAmount})
              console.log(`New ${crypto.toUpperCase()} payment address: ${paymentAddr}`)
              // DON'T start payment checking yet - wait until wallet is selected and QR generated
              // this.checkPaymentTimer = setTimeout(this.checkPayment, 500, addr)
            })
            .catch(err => {
              console.error('Error generating payment address:', err)
            })
        })
        .catch(err => {
          console.error('Error fetching price:', err)
        })
    })
  }

	checkPayment(paymentAddr, attemptNumber = 0) {
		let checkUrl
    const selectedCrypto = this.state.selectedCrypto || 'doge';
    checkUrl = `${getApiBaseUrl()}/payments/${paymentAddr}.json?full=1&crypto=${selectedCrypto}`

    // Smart polling strategy:
    // First 60 seconds: poll every 1s (60 attempts)
    // 60-120 seconds: poll every 2s (30 attempts)
    // After 120 seconds: payment will be cancelled by maxPaymentTimer
    const getPollingInterval = (attempt) => {
      if (attempt < 60) return 1000;      // 0-60 seconds: 1s intervals
      if (attempt < 90) return 2000;      // 60-120 seconds: 2s intervals (60 + 30*2s = 120s)
      // Should never reach here - maxPaymentTimer will cancel at 120s
      return 2000;
    };

    console.log(`🔍 Checking payment for: ${paymentAddr} (attempt #${attemptNumber + 1})`)
    console.log('📡 Payment check URL:', checkUrl)

		fetch(checkUrl)
      .then(res => {
        console.log('📥 Payment check response status:', res.status)
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}: ${res.statusText}`)
        }
        return res.json()
      })
			.then(payload => {
				console.log('💰 Payment payload:', payload)
				console.log('bal rcvd:', payload.received)
        console.log('amount expected:', payload.amount)

        // Payment tolerance: Accept if within ±5% OR meets 98% threshold
        // Updated 2026-01-04: Match backend logic with 5% tolerance
        const TOLERANCE_PERCENTAGE = 0.05; // 5%
        const tolerance = payload.amount * TOLERANCE_PERCENTAGE;
        const withinTolerance = payload.received >= (payload.amount - tolerance) &&
                               payload.received <= (payload.amount + tolerance);
        const meetsThreshold = payload.received >= payload.amount * 0.98;
        const isPaymentComplete = withinTolerance || meetsThreshold;

        console.log('threshold (98%):', payload.amount * 0.98)
        console.log('tolerance (±5%):', tolerance)
        console.log('within tolerance?', withinTolerance)
        console.log('meets threshold?', meetsThreshold)
        console.log('payment complete?', isPaymentComplete)

				if (isPaymentComplete) {
					console.log('🎉 PAYMENT RECEIVED - TRIGGERING CELEBRATIONS!')

          // Clear the payment check timer since payment is complete
          if (this.checkPaymentTimer) {
            console.log('⏹️ Clearing payment check timer')
            clearTimeout(this.checkPaymentTimer)
            this.checkPaymentTimer = null
          }

          // Clear the max payment timeout since payment was received
          if (this.maxPaymentTimer) {
            console.log('⏹️ Clearing max payment timeout')
            clearTimeout(this.maxPaymentTimer)
            this.maxPaymentTimer = null
          }

					this.setState({rcvd: payload.received, remainder: null})

          // Try to play audio with error handling
          console.log('🔔 Attempting to play bell sound...')
          console.log('Audio element exists?', !!this.audio)
          this.audio.play()
            .then(() => {
              console.log('✅ Bell sound played successfully!')
            })
            .catch(err => {
              console.error('❌ Audio play failed:', err)
              console.error('This is usually due to browser autoplay policy')
              console.error('User interaction required before audio can play')
            })

          // Trigger crypto rain animation
          const selectedCrypto = this.state.selectedCrypto || 'doge';
          console.log(`🌧️ Triggering ${selectedCrypto.toUpperCase()} rain animation...`)
          try {
            this.triggerDogeRain()
            console.log(`✅ ${selectedCrypto.toUpperCase()} rain triggered!`)
          } catch(err) {
            console.error(`❌ ${selectedCrypto.toUpperCase()} rain failed:`, err)
          }

          setTimeout(()=>{window.location='/'}, 1000 * 60 * 5)
        } else if (payload.received > 0) {
          let remainder = payload.amount-payload.received
					this.setState({rcvd: payload.received, remainder})
					console.log(`partial payment received (${payload.received} of ${payload.amount})...`)
          let paymentAmount = remainder
          this.setState({paymentAmount}, () => {
              QRCode.toDataURL(this.paymentUrl(), this.setQRCode)
            }
          )
          const nextInterval = getPollingInterval(attemptNumber);
					this.checkPaymentTimer = setTimeout(this.checkPayment, nextInterval, paymentAddr, attemptNumber + 1)
				} else {
					console.log('payment pending...')
          const nextInterval = getPollingInterval(attemptNumber);
          console.log(`⏰ Next check in ${nextInterval/1000}s`)
					this.checkPaymentTimer = setTimeout(this.checkPayment, nextInterval, paymentAddr, attemptNumber + 1)
				}
			})
      .catch(err => {
        console.error('❌ Payment check failed:', err)
        console.error('URL was:', checkUrl)
        const nextInterval = getPollingInterval(attemptNumber);
        console.error(`Retrying in ${nextInterval/1000} seconds...`)
        // Retry even if there's an error
        this.checkPaymentTimer = setTimeout(this.checkPayment, nextInterval, paymentAddr, attemptNumber + 1)
      })
	}

	setQRCode(err, url) {
		this.setState({qrCodeUrl: url});
		// const socket = socketIO.connect("http://b3-well.com:4567");
		// socket.on("sendSockets", (sockets) => {
		// 	console.log(`sockets: ${sockets}`)
		//     });
	}

  handleAdminClick() {
    this.setState({ showAdminPasswordPrompt: true });
  }

  async handleAdminPasswordSubmit(pw) {
    // Retrieve stored password from AsyncStorage
    const storedPassword = await AsyncStorage.getItem('storePassword');

    // Compare against stored password, or fall back to hardcoded for legacy stores
    const correctPassword = storedPassword || 'asdffdsa';

    if (pw === correctPassword) {
      this.setState({ showAdminPasswordPrompt: false });
      window.location = '/admin'
    } else {
      window.alert('Incorrect password');
    }
  }

  handleSystemClick() {
    this.setState({ showSystemPasswordPrompt: true });
  }

  handleSystemPasswordSubmit(pw) {
    if (pw === 'owner123') {
      this.setState({ showSystemPasswordPrompt: false });
      window.location = '/system'
    } else {
      window.alert('Incorrect password');
    }
  }

  triggerDogeRain() {
    const selectedCrypto = this.state.selectedCrypto || 'doge';
    console.log(`🎉 Triggering ${selectedCrypto.toUpperCase()} rain animation!`);

    // Remove any existing rain container to prevent overlapping animations
    const existingContainer = document.getElementById('doge-rain-container');
    if (existingContainer) {
      console.log('⚠️ Removing existing rain animation');
      document.body.removeChild(existingContainer);
    }

    // Create container for falling coins
    const rainContainer = document.createElement('div');
    rainContainer.id = 'doge-rain-container';
    rainContainer.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      pointer-events: none;
      z-index: 9999;
      overflow: hidden;
    `;
    document.body.appendChild(rainContainer);

    // Create multiple falling coins
    for (let i = 0; i < 25; i++) {
      this.createFallingDoge(rainContainer, i * 200, selectedCrypto);
    }

    // Remove the container after animation completes
    setTimeout(() => {
      if (document.getElementById('doge-rain-container')) {
        document.body.removeChild(rainContainer);
      }
    }, 4000);
  }

  createFallingDoge(container, delay, crypto = 'doge') {
    // Select the correct icon based on cryptocurrency
    let coinIcon;
    let coinName;

    console.log(`🪙 Creating coin with crypto param: "${crypto}"`);

    if (crypto === 'btc') {
      coinIcon = btcIcon;
      coinName = 'Bitcoin';
      console.log('  → Using Bitcoin icon:', btcIcon);
    } else if (crypto === 'ltc') {
      coinIcon = ltcIcon;
      coinName = 'Litecoin';
      console.log('  → Using Litecoin icon:', ltcIcon);
    } else {
      coinIcon = icon; // Default to Doge
      coinName = 'Dogecoin';
      console.log('  → Using Dogecoin icon:', icon);
    }

    const doge = document.createElement('img');
    doge.src = coinIcon;
    doge.setAttribute('data-crypto', coinName); // Add for debugging
    console.log(`  → Image src set to: ${coinIcon}`);
    doge.style.cssText = `
      position: absolute;
      width: 40px;
      height: 40px;
      top: -50px;
      left: ${Math.random() * 100}vw;
      animation: fall 3s linear forwards;
      animation-delay: ${delay}ms;
      transform: rotate(${Math.random() * 360}deg);
    `;

    // Add CSS keyframes for falling animation
    if (!document.getElementById('doge-rain-styles')) {
      const style = document.createElement('style');
      style.id = 'doge-rain-styles';
      style.innerHTML = `
        @keyframes fall {
          to {
            transform: translateY(110vh) rotate(720deg);
            opacity: 0;
          }
        }
      `;
      document.head.appendChild(style);
    }

    container.appendChild(doge);

    // Remove individual coin after animation
    setTimeout(() => {
      if (doge.parentNode) {
        doge.parentNode.removeChild(doge);
      }
    }, 3000 + delay);
  }

	getDogeUSDRate(p) {
    if (p) {
  		return p * this.state.fiatConversionRate;
    } else {
  		return this.state.price * this.state.fiatConversionRate;
    }
	}

	total() {
    if (this.state.posMode === 'square') {
      return (this.state.squareOrder.total_money.amount||0)/100
    } else if(this.state.posMode === 'toast') {
      return (this.state.toastOrder.total_money.amount||0)
    } else {
      if (this.state.numerals.length === 0) {
        return 0
      } else {
    		return (parseFloat(this.state.numerals.join(''))/100);
      }
    }
	}

  tip() {
    if (this.state.posMode === 'square') {
      return (this.state.squareOrder.total_tip_money.amount||0)/100
    } else if(this.state.posMode === 'toast') {
      return (this.state.toastOrder.total_tip_money.amount||0)
    } else {
      var tip = 0
      if (this.state.tipSelect === 'tip-5-flat') {
        return 5
      } else if (this.state.tipSelect === 'tip-10-flat') {
        return 10
      } else if (this.state.tipSelect === 'tip-20-flat') {
        return 20
      } else if (this.state.tipSelect === 'tip-cust') {
        return this.state.customTip
      } else {
        if (this.state.tipSelect === 'tip-25') { tip = 0.25 }
        else if (this.state.tipSelect === 'tip-20') { tip = 0.20 }
        else if (this.state.tipSelect === 'tip-18') { tip = 0.18 }
        else if (this.state.tipSelect === 'tip-no') { tip = 0.0 }
        return tip * this.total()
      }
    }
  }

  finalBalance() {
    let discount = this.state.discount ? 1 - (this.state.discount/100) : 1;
    let balance = (this.total() * discount) + this.tip();

    // Apply fee passthrough markup if enabled
    // This increases the price so the retailer receives approximately 100% of entered amount
    if (this.state.feePassthrough === true || this.state.feePassthrough === 'true') {
      const feePercent = this.state.dijittoFeePercentage || 2.5;
      balance = balance / (1 - feePercent / 100);
    }

    return balance;
  }

  finalDogeBalance(price) {
    return this.finalBalance()/this.getDogeUSDRate(price)
  }

  selectStyles() {
    const styles = {
      width: '60px',
      menu: (base) => ({
        ...base,
        zIndex: 9999,
        backgroundColor: 'white',
        boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
      }),
      menuPortal: (base) => ({
        ...base,
        zIndex: 9999
      }),
      menuList: (base) => ({
        ...base,
        backgroundColor: 'white',
        "::-webkit-scrollbar": {
          width: "14px",
          height: "0px",
        },
        "::-webkit-scrollbar-track": {
          background: "#f1f1f1"
        },
        "::-webkit-scrollbar-thumb": {
          background: "#888"
        },
        "::-webkit-scrollbar-thumb:hover": {
          background: "#555"
        }
      }),
      option: (base) => ({
        ...base,
        backgroundColor: 'white',
        '&:hover': {
          backgroundColor: '#f0f0f0'
        }
      })
    }
    return styles
  }

	render() {
    // Payment screen
		if (this.state.page === 3) {
			return (
        <>
        {
          this.state.rcvd ? (
            !this.state.remainder ? (
              <Canvas height={"1180px"} width={"1180px"} crypto={this.state.selectedCrypto || 'doge'} />
            ) : (<></>)
          ) : (<></>)
        }
				<div style={{backgroundColor: 'white', height: '100vh', color: '#333', fontSize: '30px', paddingBottom: 'max(60px, env(safe-area-inset-bottom, 0px))'}}>
					<Row>
						<Col sm={{span: 6}} style={{paddingTop: '20px'}}>
					 		<Row style={{backgroundColor: '#1E3A8A', heightt: '200px', margin: '10px', borderRadius: '4px', color: 'white'}}>
								<Col>

                  {
                    (this.state.storeId !== 0 && this.state.tipOnlyMode !== 'true') ? (
                      <>
      									<Row>
      										<Col style={{textAlign: 'left'}} sm={{ span: 7 }}>Subtotal:</Col>
      										<Col style={{textAlign: 'right'}} sm={{ span: 5}}>{this.state.fiatSymbol || '$'}{this.total().toFixed(2)}</Col>
      									</Row>

      									{
                          this.state.discount && this.state.discount > 0 ? (
          									<Row>
          										<Col style={{textAlign: 'left', fontSize: '24px'}} sm={{ span: 9 }}>Ðijitto Discount {this.state.discount}%:</Col>
          										<Col style={{textAlign: 'right', fontSize: '24px'}} sm={{ span: 3 }}>{"-" + (this.state.fiatSymbol || '$') + (this.total()*((this.state.discount || 0)/100)).toFixed(2)}</Col>
          									</Row>
                          ) : (
                            <></>
                          )
      									}
                      </>
                    ) : (<></>)
                  }

									{
  									this.state.tipsMode === 'false' ? (<></>) : (
                      <Row>
    										<Col style={{textAlign: 'left'}} sm={{ span: 7 }}>Tip:</Col>
    										<Col style={{textAlign: 'right'}} sm={{ span: 5 }}>{this.state.fiatSymbol || '$'}{this.tip().toFixed(2)}</Col>
    									</Row>
                    )
									}

                  {
                    this.state.storeId !== 0 ? (
    									<Row>
    										<Col style={{textAlign: 'left'}} sm={{ span: 7 }}>Balance due:</Col>
                        <Col style={{textAlign: 'right'}} sm={{ span: 5 }}>{this.state.fiatSymbol || '$'}{this.finalBalance().toFixed(2)}</Col>
    									</Row>
                    ) : (<></>)
                  }

									<Row>
										<Col style={{textAlign: 'left', whiteSpace: 'nowrap', overflow: 'hidden'}} sm={{ span: 7 }}>
                      {this.state.selectedCrypto === 'btc' ? 'BTC' : this.state.selectedCrypto === 'ltc' ? 'LTC' : 'Doge'} due:
                    </Col>
										<Col style={{
                        textAlign: 'right',
                        fontSize: this.state.selectedCrypto === 'btc' || this.state.selectedCrypto === 'ltc' ? '24px' : '30px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap'
                      }} sm={{ span: 5 }}>
                      {this.state.selectedCrypto === 'btc' ? '₿' : this.state.selectedCrypto === 'ltc' ? 'Ł' : 'Ɖ'}
                      {this.finalDogeBalance().toFixed(this.state.selectedCrypto === 'btc' ? 8 : this.state.selectedCrypto === 'ltc' ? 6 : 2)}
                    </Col>
									</Row>

								</Col>
							</Row>

              {/* QR Code - displayed below totals on left side */}
              {this.state.qrCodeUrl && !this.state.rcvd && (
                <Row style={{marginTop: '20px', textAlign: 'center', paddingBottom: '180px'}}>
                  <Col>
                    <div style={{fontSize: '18px', marginBottom: '10px'}}>Scan to pay</div>
                    <img alt='Payment QR Code' style={{width: '180px', height: '180px', borderRadius: '6px'}} src={this.state.qrCodeUrl} />
                    <div style={{fontSize: '12px', marginTop: '10px', color: '#666'}}>
                      Send only {this.state.selectedCrypto === 'btc' ? 'Bitcoin (BTC)' : this.state.selectedCrypto === 'ltc' ? 'Litecoin (LTC)' : 'Dogecoin (DOGE)'} to this address.
                    </div>

                    {/* Home/Cancel - Powered by DijittoExpress text (portrait only) */}
                    {window.innerHeight > window.innerWidth && (
                      <div
                        onClick={this.handleReset}
                        style={{
                          marginTop: '20px',
                          cursor: 'pointer',
                          display: 'inline-block',
                          padding: '15px 25px'
                        }}
                      >
                        <span style={{fontSize: '12px', color: '#6B7280', fontWeight: '500'}}>Powered by </span>
                        <span style={{fontSize: '14px', fontWeight: '700'}}>
                          <span style={{color: '#1E3A8A'}}>Dijitto</span><span style={{color: '#374151'}}>Express</span>
                        </span>
                      </div>
                    )}
                  </Col>
                </Row>
              )}
						</Col>

						<Col sm={{span: 6}}>
								{/* Hide header on small phones in portrait when QR is showing - we have "Powered by" below QR */}
								{!(window.innerHeight > window.innerWidth && window.innerWidth < 768 && this.state.qrCodeUrl) && (
									<>
										<Row style={{height: 'min(10vh,8vw)'}} />

										<Row style={{fontSize: '44px', textAlign: 'center'}}>
											<Col onClick={this.handleReset} style={{cursor: 'pointer', position: 'relative', zIndex: 1}}>
												<span style={{fontWeight: '700', color: '#1E3A8A'}}>Dijitto</span><span style={{fontWeight: '700', color: '#374151'}}>Express</span>
											</Col>
										</Row>

										<Row style={{height: 'min(8vh,6vw)'}} />
									</>
								)}

                {
									!this.state.rcvd ? (
                    <>
                      {/* Cryptocurrency Selection - FIRST (correct flow) */}
                      <Row style={{marginBottom: '20px'}}>
                        <div style={{textAlign: 'left', marginBottom: '8px', fontSize: '20px'}}>Select Payment Currency</div>
                        <div style={{display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap'}}>
                          {this.state.availableCryptos.includes('btc') && (
                            <button
                              onClick={() => this.handleSelectCrypto('btc')}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '10px 20px',
                                borderRadius: '25px',
                                border: this.state.selectedCrypto === 'btc' ? '3px solid #F7931A' : '2px solid #444',
                                backgroundColor: this.state.selectedCrypto === 'btc' ? 'rgba(247, 147, 26, 0.1)' : 'transparent',
                                color: '#333',
                                cursor: 'pointer',
                                transition: 'all 0.2s'
                              }}
                            >
                              <span style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '28px',
                                height: '28px',
                                borderRadius: '50%',
                                backgroundColor: '#F7931A',
                                marginRight: '8px',
                                fontSize: '16px',
                                fontWeight: 'bold'
                              }}>₿</span>
                              Bitcoin
                            </button>
                          )}
                          {this.state.availableCryptos.includes('ltc') && (
                            <button
                              onClick={() => this.handleSelectCrypto('ltc')}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '10px 20px',
                                borderRadius: '25px',
                                border: this.state.selectedCrypto === 'ltc' ? '3px solid #345D9D' : '2px solid #444',
                                backgroundColor: this.state.selectedCrypto === 'ltc' ? 'rgba(52, 93, 157, 0.1)' : 'transparent',
                                color: '#333',
                                cursor: 'pointer',
                                transition: 'all 0.2s'
                              }}
                            >
                              <span style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '28px',
                                height: '28px',
                                borderRadius: '50%',
                                backgroundColor: '#345D9D',
                                marginRight: '8px',
                                fontSize: '16px',
                                fontWeight: 'bold'
                              }}>Ł</span>
                              Litecoin
                            </button>
                          )}
                          {this.state.availableCryptos.includes('doge') && (
                            <button
                              onClick={() => this.handleSelectCrypto('doge')}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '10px 20px',
                                borderRadius: '25px',
                                border: this.state.selectedCrypto === 'doge' ? '3px solid #C2A633' : '2px solid #444',
                                backgroundColor: this.state.selectedCrypto === 'doge' ? 'rgba(194, 166, 51, 0.1)' : 'transparent',
                                color: '#333',
                                cursor: 'pointer',
                                transition: 'all 0.2s'
                              }}
                            >
                              <span style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '28px',
                                height: '28px',
                                borderRadius: '50%',
                                backgroundColor: '#C2A633',
                                marginRight: '8px',
                                fontSize: '16px',
                                fontWeight: 'bold'
                              }}>Ɖ</span>
                              Dogecoin
                            </button>
                          )}
                        </div>
                      </Row>

                      {/* Wallet Selection - AUTO-POSITIONING DROPDOWN (Solution C) */}
                      {this.state.selectedCrypto && (
                        <Row style={{marginBottom: 'max(40px, env(safe-area-inset-bottom, 0px))'}}>
                          {
                            this.state.qrCodeUrl ? <></> :
                            <div style={{fontSize: '20px', marginBottom: '8px'}}>Select Your Wallet</div>
                          }
                          <div style={{width: '95%', color: 'black'}}>
                             <Select
                               styles={this.selectStyles()}
                               name='walletApp'
                               onChange={(sel) => {this.handleChooseWallet(sel)}}
                               menuPlacement="auto"
                               options={[
                                 {value: 'MyDoge', label: <img alt='' src={mydoge} style={{height: '45px'}}/>},
                                 {value: 'Coinbase Wallet', label: <img alt='' src={coinbase} style={{height: '45px'}}/>},
                                 {value: 'Coinbase', label: <span style={{fontWeight: '500'}}>Coinbase</span>},
                                 {value: 'Exodus', label: <img alt='' src={exodus} style={{height: '45px'}}/>},
                                 {value: 'Trust Wallet', label: <img alt='' src={trust} style={{height: '45px'}}/>},
                                 {value: 'Atomic Wallet', label: <img alt='' src={atomic} style={{height: '45px'}}/>},
                                 {value: 'Safe Pal', label: <img alt='' src={safepal} style={{height: '45px'}}/>},
                                 {value: 'Other', label: <span style={{fontWeight: '500'}}>Other</span>},
                               ]}
                               isSearchable={false}
                               placeholder="Select..."
                               value={this.state.walletApp}
                               />
                             </div>
                        </Row>
                      )}

                    </>
                  ) : (
                    this.state.remainder ? (
                      <>
        								<Row style={{textAlign: 'center'}}>
                          <Col>Partial payment received Ð{this.state.rcvd}. Please scan this code to complete remaining payment of Ð{this.state.remainder.toFixed(2)}</Col>
        								</Row>

        								<Row style={{height: 'min(8vh,6vw)'}} />

        								<Row style={{textAlign: 'center'}}>
        									<Col>
        										<img alt='' style={{width: 'min(25vh,32vw)'}} src={this.state.qrCodeUrl} />
        									</Col>
        								</Row>

        								<Row style={{height: '50px'}} />
                      </>
                    ) : (
                      <></>
                    )
                  )
                }

						</Col>
					</Row>
                {
  								this.state.rcvd ? (
                    !this.state.remainder ? (
                      <>
      									<Row style={{textAlign: 'center'}}>
      										<Col sm={{span: 2}} />
      										<Col style={{
                          color: 'rgb(196,166,51)',
                          fontSize: '65px',
                          fontFamily: "'SF Pro Display', 'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif",
                          fontWeight: '600',
                          letterSpacing: '-0.5px'
                        }}>
                          Payment Received! {this.state.selectedCrypto === 'btc' ? '₿' : this.state.selectedCrypto === 'ltc' ? 'Ł' : 'Ɖ'}{this.state.rcvd.toFixed(this.state.selectedCrypto === 'btc' ? 8 : this.state.selectedCrypto === 'ltc' ? 6 : 2)}
                        </Col>
      										<Col sm={{span: 2}} />
      									</Row>
      									<Row style={{textAlign: 'center', marginTop: '30px'}}>
      										<Col>
                            <div
                              onClick={this.handleReset}
                              style={{
                                cursor: 'pointer',
                                display: 'inline-block',
                                padding: '15px 25px'
                              }}
                            >
                              <span style={{fontSize: '14px', color: '#6B7280', fontWeight: '500'}}>Powered by </span>
                              <span style={{fontSize: '16px', fontWeight: '700'}}>
                                <span style={{color: '#1E3A8A'}}>Ðijitto</span><span style={{color: '#374151'}}>Express</span>
                              </span>
                            </div>
                          </Col>
      									</Row>
                      </>
                    ) : (<></>)
  								) : (<></>)
                }
				</div>
        </>
			);
		}

    // Tip screen
		if (this.state.page === 2) {
			return (
        <>
          <Tip storeId={this.state.storeId} tipSelect={this.state.tipSelect} handleTip={this.handleTip} total={this.total} customTip={this.state.customTip} fiatSymbol={this.state.fiatSymbol} handleContinueClick={this.handleContinueClick} tipOnlyMode={this.state.tipOnlyMode === 'true'} />

          {/* Custom Tip Modal */}
          <Modal
            show={this.state.showCustomTipModal}
            onHide={this.handleCustomTipCancel}
            centered
            size="lg"
          >
            <Modal.Header closeButton>
              <Modal.Title>Enter Custom Tip</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {/* Display */}
              <div style={{
                background: '#f8f9fa',
                border: this.state.customTipError ? '3px solid #dc3545' : '3px solid #28a745',
                borderRadius: '12px',
                padding: '24px',
                marginBottom: '24px',
                textAlign: 'center'
              }}>
                <div style={{
                  fontSize: '48px',
                  fontWeight: 'bold',
                  color: '#333',
                  fontFamily: 'monospace',
                  letterSpacing: '2px'
                }}>
                  {this.state.fiatSymbol || '$'}{this.formatTipDisplay(this.state.customTipInput)}
                </div>
                {this.state.customTipError && (
                  <div style={{
                    color: '#dc3545',
                    fontSize: '14px',
                    marginTop: '12px',
                    fontWeight: '500'
                  }}>
                    {this.state.customTipError}
                  </div>
                )}
              </div>

              {/* Keypad */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '12px',
                maxWidth: '400px',
                margin: '0 auto'
              }}>
                {/* Numbers 1-9 */}
                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(num => (
                  <button
                    key={num}
                    onClick={() => this.handleTipKeypadPress(num.toString())}
                    style={{
                      padding: '20px',
                      fontSize: '28px',
                      fontWeight: 'bold',
                      border: '2px solid #dee2e6',
                      borderRadius: '8px',
                      background: 'white',
                      cursor: 'pointer',
                      transition: 'all 0.15s',
                      color: '#333'
                    }}
                    onMouseDown={(e) => e.target.style.transform = 'scale(0.95)'}
                    onMouseUp={(e) => e.target.style.transform = 'scale(1)'}
                    onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                  >
                    {num}
                  </button>
                ))}

                {/* .00 Button */}
                <button
                  onClick={() => this.handleTipKeypadPress('.00')}
                  style={{
                    padding: '20px',
                    fontSize: '28px',
                    fontWeight: 'bold',
                    border: '2px solid #28a745',
                    borderRadius: '8px',
                    background: '#d4edda',
                    cursor: 'pointer',
                    transition: 'all 0.15s',
                    color: '#155724'
                  }}
                  onMouseDown={(e) => e.target.style.transform = 'scale(0.95)'}
                  onMouseUp={(e) => e.target.style.transform = 'scale(1)'}
                  onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                >
                  .00
                </button>

                {/* 0 Button */}
                <button
                  onClick={() => this.handleTipKeypadPress('0')}
                  style={{
                    padding: '20px',
                    fontSize: '28px',
                    fontWeight: 'bold',
                    border: '2px solid #dee2e6',
                    borderRadius: '8px',
                    background: 'white',
                    cursor: 'pointer',
                    transition: 'all 0.15s',
                    color: '#333'
                  }}
                  onMouseDown={(e) => e.target.style.transform = 'scale(0.95)'}
                  onMouseUp={(e) => e.target.style.transform = 'scale(1)'}
                  onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                >
                  0
                </button>

                {/* Backspace Button */}
                <button
                  onClick={() => this.handleTipKeypadPress('backspace')}
                  style={{
                    padding: '20px',
                    fontSize: '24px',
                    fontWeight: 'bold',
                    border: '2px solid #ffc107',
                    borderRadius: '8px',
                    background: '#fff3cd',
                    cursor: 'pointer',
                    transition: 'all 0.15s',
                    color: '#856404'
                  }}
                  onMouseDown={(e) => e.target.style.transform = 'scale(0.95)'}
                  onMouseUp={(e) => e.target.style.transform = 'scale(1)'}
                  onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
                >
                  ⌫
                </button>
              </div>

              <div style={{
                textAlign: 'center',
                marginTop: '16px',
                color: '#666',
                fontSize: '14px'
              }}>
                Tap numbers to enter tip amount
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={this.handleCustomTipCancel}
                style={{ fontSize: '16px', padding: '10px 24px' }}
              >
                Cancel
              </Button>
              <Button
                variant="success"
                onClick={this.handleCustomTipSubmit}
                style={{ fontSize: '16px', padding: '10px 24px', fontWeight: 'bold' }}
              >
                Confirm {this.state.fiatSymbol || '$'}{this.formatTipDisplay(this.state.customTipInput)}
              </Button>
            </Modal.Footer>
          </Modal>
        </>
			)
		}

    // Data entry screen
    if (this.state.page === 0) {
  		return (
        <>
          <DataEntry storeId={this.state.storeId} handleAdminClick={this.handleAdminClick} numerals={this.state.numerals} order={this.state.order} toggleEntry={this.toggleEntry} keypadToggle={this.state.keypadToggle} total={this.total} fiatSymbol={this.state.fiatSymbol} handleClickDoge={this.handleClickDoge} handleKeyClick={this.handleKeyClick} />

          {/* Password Prompts */}
          <PasswordPrompt
            show={this.state.showAdminPasswordPrompt}
            title="Admin Login"
            message="Enter your store password to access the admin panel."
            onSubmit={(pw) => this.handleAdminPasswordSubmit(pw)}
            onCancel={() => this.setState({ showAdminPasswordPrompt: false })}
          />
        </>
  		);
    } else {
      // Splash screen
      return (
        <>
          <Splash
            handleClickSplash={this.handleClickSplash}
            handleAdminClick={this.handleAdminClick}
            handleSystemClick={this.handleSystemClick}
            storeId={this.state.storeId}
            splashImage={this.state.splash}
            topText={this.state.topText}
            middleText={this.state.middleText}
            bottomText={this.state.bottomText}
            tipOnlyMode={this.state.tipOnlyMode === 'true'}
          />

          {/* Password Prompts */}
          <PasswordPrompt
            show={this.state.showAdminPasswordPrompt}
            title="Admin Login"
            message="Enter your store password to access the admin panel."
            onSubmit={(pw) => this.handleAdminPasswordSubmit(pw)}
            onCancel={() => this.setState({ showAdminPasswordPrompt: false })}
          />
          <PasswordPrompt
            show={this.state.showSystemPasswordPrompt}
            title="System Login"
            message="Enter the owner password to access the system panel."
            onSubmit={(pw) => this.handleSystemPasswordSubmit(pw)}
            onCancel={() => this.setState({ showSystemPasswordPrompt: false })}
          />
        </>
      )
    }
	}
}

export default Main;
